import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import AgreementWebViewNSignature from "../../../components/AgreementsDetails/AgreementWebViewNSignature";

const AgreementWebView = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
      <Box sx={{ flexGrow: 1 }} className="page-background">
        <AgreementWebViewNSignature />
      </Box>
    </>
  );
};

export default AgreementWebView;
